/**
 * The closed set of quick-action flows the widget can dispatch.
 *
 * This lives in its own module rather than in `index.ts` so that siblings
 * `index.ts` re-exports can import the values without a load-time cycle: a
 * sibling importing from `index.ts` is evaluated before that file's body runs,
 * so the const would still be in its temporal dead zone.
 */
const QuickActionId = {
    CaptureLead: 'capture_lead',
    TextUs: 'text_us',
    BookAppointment: 'book_appointment', // composite: captureLead → createBooking, one submit
    PreQualify: 'pre_qualify', // wraps the shared submitPrequal entry
};

export { QuickActionId };
//# sourceMappingURL=quick-action-id.js.map
